export class Perfis {
    static AdministradorSistema = '#ADMINISTRADORSISTEMA';
    static GestorDex = '#GESTORDEX';
    static AdministrativoDex = '#ADMINISTRATIVODEX';
    static GestorUnidadeOperacional = '#GESTORUNIDADEOPERACIONAL';
    static AdministrativoUnidadeOperacional = '#ADMINISTRATIVOUNIDADEOPERACIONAL';
    static Financeiro = '#FINANCEIRO';
}


export class Perfil {
    IdSistemaPerfil: string;
    NomePerfil: string;
    ReferenciaPerfil: string;
    Descricao: string;
    Ativo: boolean;
    IdSistema: string;
    NomeSistema: string;
}



// WEBPACK FOOTER //
// ./src/app/models/perfis.ts